module.exports = __webpack_public_path__ + "media/images/flags/64/Solomon-Islands-b49c42cc390a400b55d509bd19a3e8e1.png";